import classes from './AvailableMeals.module.css';
import MealItem from './MealItem/MealItem';
import Card from '../UI/Card';


const DUMMY_MEALS = [
    {
      id: 'm1',
      name: 'Sushi',
      description: 'Finest fish and veggies',
      price: 22.99,
    },
    {
      id: 'm2',
      name: 'Schnitzel',
      description: 'A german specialty!',
      price: 16.5,
    },
    {
      id: 'm3',
      name: 'Barbecue Burger',
      description: 'American, raw, meaty',
      price: 12.99,
    },
    {
      id: 'm4',
      name: 'Green Bowl',
      description: 'Healthy...and green...',
      price: 18.99,
    },
  ];

const AvailableMeals = () => {
    const mealsList = DUMMY_MEALS.map(meal => 
        <MealItem 
            id={meal.id}
            key={meal.id} 
            // meal={meal} and in Meal item write e.g. props.meal.description 
            name={meal.name} 
            description={meal.description} 
            price={meal.price} 
        />);
    return <section className={classes.meals}>
        <ul><Card>{mealsList}</Card></ul>
    </section>
}
export default AvailableMeals;